import { Button, Form } from 'react-bootstrap';
import { getItemWebStorage, setItemWebStorage } from '../../features/webStorageSaver/webStorageSaver';
import { useDispatch } from 'react-redux';
import { setPanoramaDirectionFilter, setPanoramaSeasonFilter, setPanoramaStep, setPanoramaYearFilter } from '../../stateManagement/reducers/PanoramaSlice';
import { useAppSelector } from '../../stateManagement/hooks/redux';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { classNames } from 'primereact/utils';

// Страница выбора дополнительных слоев для карты
export function PanoramaFilters({ type }: any) {
    const dispatch = useDispatch();
    const panoramaYearFilter = useAppSelector(state => state.panorama.panoramaYearFilter)
    const panoramaSeasonFilter = useAppSelector(state => state.panorama.panoramaSeasonFilter)
    const panoramaDirectionFilter = useAppSelector(state => state.panorama.panoramaDirectionFilter)
    const panoFiltersData = useAppSelector(state => state.panorama.panoramaFilters)
    const [filteredData, setFilteredData] = useState(panoFiltersData);
    const newLocalRosreestr = useState(getItemWebStorage("mapSettings")?.rosreestr);
    const xmlData = useAppSelector(state => state.panorama.xml)
    const navigate = useNavigate()

    const currentConfig = getItemWebStorage('currentConfig');
    const isFilterDateActive = currentConfig.panoFilterDate;

    // Функция для конвертации сезона из xml в читаемые селекторы 
    function displaySeasonValue(season: string | undefined) {
        // Если direction равно 1, то меняем значение для отображения на "прямое"
        if (season === '1') {
            return 'Зима';
        } else if (season === '2') {
            // Если direction равно 0, то меняем значение для отображения на "обратное"
            return 'Весна';
        } else if (season === '3') {
            return 'Лето';
        } else if (season === '4') {
            // Если direction равно 0, то меняем значение для отображения на "обратное"
            return 'Осень';
        } else if (season === '0') {
            // Если direction равно 0, то меняем значение для отображения на "обратное"
            return 'Все';
        }
    }
    function displayYearValue(year: string | undefined) {
        if (year === '0') {
            return 'Все'
        } else return year
    }

    // Создаем множества для уникальных значений года, сезона и направления
    const uniqueYears = new Set();
    const uniqueSeasons = new Set();
    const uniqueDirections = new Set();
    // Заполняем множества уникальными значениями на основе данных
    filteredData && filteredData.forEach((item: { Year: string; Season: string; VideoDocumentDirection: string; }) => {
        uniqueYears.add(item.Year);
        uniqueDirections.add(item.VideoDocumentDirection);
        uniqueSeasons.add(item.Season);
    });
    // Преобразуем множества в массивы для использования в селекторах панорамы
    // Сортировка годов в порядке возрастания
    const yearOptions = ['0', ...Array.from(uniqueYears).map(String)].sort((a, b) => {
        return parseInt(a) - parseInt(b);
    });
    // Сортировка сезонов в порядке возрастания
    let seasonOptions = ['0', ...Array.from(uniqueSeasons).map(String)].sort((a, b) => {
        return parseInt(a) - parseInt(b);
    });
    // Направление движения камеры по дороге на карте
    const directionOptions = ['Все', ...Array.from(uniqueDirections).map(String)];
    // Перерисовываем от кадра панорамы, обновляем значения селекторов
    useEffect(() => {
        let filteredResult = panoFiltersData;
        setFilteredData(filteredResult);
    }, [panoFiltersData, newLocalRosreestr, xmlData, panoramaYearFilter]);

    function defaultSeasonAndDirection() {
        dispatch(setPanoramaDirectionFilter(directionOptions[0]));
        dispatch(setPanoramaSeasonFilter(seasonOptions[0]));
    }

    let mainDivClassName = classNames({
        "panorama-filters-page": type === "page",
        "panorama-filters-header": type !== "page"
    })

    return (
        <div className={mainDivClassName}>
            {(isFilterDateActive || isFilterDateActive === undefined) &&
                <>
                    <Form.Label className="pano-filter-label" htmlFor="year-select">год</Form.Label>
                    <Form.Select id="year-select" size="sm" aria-label="год" onChange={(e) => {
                        dispatch(setPanoramaYearFilter(e.target.value));
                        defaultSeasonAndDirection()
                        setItemWebStorage('panoramaYearFilter', e.target.value)
                    }}
                        value={displayYearValue(panoramaYearFilter)}
                    >
                        {yearOptions.map((year, index) => (
                            <option key={index} value={year}>{displayYearValue(year)}</option>
                        ))}
                    </Form.Select>
                    <Form.Label className="pano-filter-label" htmlFor="season-select">сезон</Form.Label>
                    <Form.Select id="season-select" aria-label="сезон" onChange={(e) => {
                        dispatch(setPanoramaSeasonFilter(e.target.value))
                        setItemWebStorage('panoramaSeasonFilter', e.target.value)
                    }}
                        value={panoramaSeasonFilter}>
                        {seasonOptions.map((season, index) => (
                            <option key={index} value={season}>{displaySeasonValue(season)}</option>
                        ))}
                    </Form.Select>
                    <Form.Label className="pano-filter-label" htmlFor="direction-select">направление</Form.Label>
                    <Form.Select id="direction-select" aria-label="направление"
                        value={panoramaDirectionFilter}
                        onChange={(e) => {
                            dispatch(setPanoramaDirectionFilter(e.target.value));
                            setItemWebStorage('panoramaDirectionFilter', e.target.value)
                        }}>
                        {directionOptions.map((direction, index) => {
                            let displayValue = direction; // Значение для отображения по умолчанию
                            // Если direction равно 1, то меняем значение для отображения на "прямое"
                            if (direction === '0') {
                                displayValue = 'Прямое';
                            } else if (direction === '1') {
                                // Если direction равно 0, то меняем значение для отображения на "обратное"
                                displayValue = 'Обратное';
                            }
                            return (
                                <option key={index} value={direction}>
                                    {displayValue}
                                </option>
                            );
                        })}
                    </Form.Select>
                </>}
            <Form.Label className="pano-filter-label" htmlFor="step-select">шаг</Form.Label>
            <Form.Select id="step-select" aria-label="шаг" onChange={(e) => {
                dispatch(setPanoramaStep(e.target.value))
                setItemWebStorage('panoramaStep', e.target.value)
            }}>
                <option value="50 м">50 м</option>
                <option value="100 м">100 м</option>
                <option value="500 м">500 м</option>
            </Form.Select>
            <br></br>
            <div className="d-grid gap-2 applyButtonContainer">
                <Button className="applyButton" variant="primary" size="sm" onClick={() => navigate(-1)}>Применить</Button>
            </div>
        </div >
    );
}

